import React, { useEffect }  from 'react';
import PageLayout from '../components/Layouts/PageLayout';
import { MainData } from '../Data/MainData';
import { Link, Navigate, useLocation, useParams } from 'react-router-dom';
import { getLanLoc } from '../components/Functions/LangFunc';
import styled from 'styled-components';
import PageBuilder from '../components/PageBuilder/PageBuilder';
import { GetDataPromise, PostDataPromise } from '../components/Functions/SendingData';
import { apiMain } from '../App';
import { LoadingFull } from '../components/LoadingFull';
import { IconRouting } from '../Assets/panels/IconRouting';
import { IconBuilding } from '../Assets/contacts/IconBuilding';
import { IconLocation } from '../Assets/contacts/IconLocation';
import { IconAgency } from '../Assets/contacts/IconAgency';
import { DictioneryPanel } from '../Data/DictioneryPanel';
import { formatPrice } from '../components/Functions/Price';
import { TextInputWTitle } from '../components/Inputs/TextInputWTitle';
import { AgeTypeV2Selector } from '../components/Inputs/AgeTypeV2Selector';
import { DateInputWTitle } from '../components/Inputs/DateInputWTitle';
import { TextBtn2 } from '../components/Inputs/TextBtn2';

const Styles = styled.div`
  display: flex;
  flex-direction: column;
  .over-tour {
    width: calc(100% - calc(var(--universal-pad) * 2) - 0);
    margin: 1rem var(--universal-pad) 1rem;
    background-color: var(--n-grey-0);
    box-shadow: 0px 4px 50px -16px #00000028;
    padding: 1.25rem;
    border-radius: var(--border-radius-32);
    position: relative;
    display: flex;
    align-items: center;
    gap: 1.5rem;
    .base {
      width: calc(70% - 1rem);
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      .title1 {
        font-size: 1.5rem;
        font-weight: 700;
      }
      .desc {
        text-decoration: none;
        color: inherit;
        display: flex;
        gap: 0.5rem;
        font-size: 0.9rem;
        font-weight: 600;
        &.big {
          margin-top: 0.3rem;
          font-size: 1.1rem;
        }
        .desc-link {
          color: var(--c-main);
        }
        svg {
          fill: var(--n-grey-2);
          width: 32px;
          height: 32px;
          display: block;
        }
        .text {
          width: calc(100% - 32px - 0.5rem);
          white-space: pre-line;
        }
      }
    }
    .image {
      width: 30%;
      max-width: 300px;
      aspect-ratio: 1.8;
      border: 1px solid var(--n-grey-1);
      border-radius: var(--border-radius-3);
      overflow: hidden;
      position: relative;
      background-color: var(--n-grey-01);
      .icon-def {
        position: absolute;
        top: calc(50% - 24px);
        right: calc(50% - 24px);
        display: block;
        fill: var(--n-grey-2);
        z-index: 1;
      }
      img {
        position: relative;
        z-index: 2;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .end {
      display: flex;
      justify-content: flex-end;
      gap: 1.25rem;
      .social {
        border-radius: 100px;
        border: 1px solid var(--n-grey-1);
        background-color: var(--n-grey-01);
        padding: 0.87rem;
        svg {
          display: block;
        }
      }
    }
  }
  .buying-forms {
    width: calc(100% - calc(var(--universal-pad) * 2) - 0);
    margin: 0 var(--universal-pad) 1rem;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1rem;
    .form-1 {
      grid-column: 3 span;
      background-color: var(--n-grey-0);
      box-shadow: 0px 4px 50px -16px #00000028;
      padding: 1.25rem;
      border-radius: var(--border-radius-32);
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 1rem;
    }
    .form-2 {
      grid-column: 1 span;
      background-color: var(--n-grey-0);
      box-shadow: 0px 4px 50px -16px #00000028;
      padding: 1.25rem;
      border-radius: var(--border-radius-32);
      display: flex;
      flex-direction: column;
      .tour-price-data {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        .total {
          margin: 1rem 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 1.05rem;
          font-weight: 700;
          .title {
            color: var(--n-grey-2);
          }
          .value {
            color: var(--c-main);
          }
        }
      }
    }
  }
  @media screen and (max-width: 850px) {
    .over-tour {
      padding: 1rem;
      flex-direction: column;
      align-items: normal;
      gap: 1rem;
      .image {
          width: 100%;
          max-width: none;
          aspect-ratio: 2.5;
      }
      .expand {
          display: none;
      }
    }
    .buying-forms {
      grid-template-columns: repeat(1, 1fr);
      .form-1 {
        grid-column: 1 span;
        grid-template-columns: repeat(1, 1fr);
        gap: 0;
      }
    }
  }
`

export default function BuyToursPage (props){
  const location = useLocation();
  const params = useParams()
  const [data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [dialogLoading, setDialogLoading] = React.useState(false);
  const [dialogError, setDialogError] = React.useState({});
  const [dataForm, setDataForm] = React.useState((props.dialogData) ? props.dialogData : {});
  const onChange = (e) => {
      const value = e.target.value;
      const name = e.target.name;
      let temp = {...dataForm};
      temp[name] = value;
      setDataForm(temp);
  }


  let {isEn: lan, isSet: isSetLan} = getLanLoc(location.pathname);
  useEffect(() => {
    if (!isNaN(parseInt(params.id))) {
      getData(params.id);
    }
  }, []);
  const getData = async (id, force) => {
    setLoading(true);
    let URLparams = new URLSearchParams();
    URLparams.append("Tour_Id", id);
    let res = await GetDataPromise(`${apiMain}/api/v2/tour/V2_tours/select_tour_detail?${URLparams.toString()}`, force);
    let parsed = JSON.parse(res);
    if((parsed.status && parsed.status !== "error" && parsed.status !== "error-no-internet") || parsed.status === "success"){
      setData(parsed.data);
    }
    setLoading(false);
  }
  const sendData = async () => {
    // 
    setDialogLoading(true);
    let keys = Object.keys(dataForm);
    let errors = {};

    let formData = new FormData();
    formData.append("Agency_Id_Organizer", data.Agency_Origin_Id);
    formData.append("Tour_Id", data.Tour_Id);
    formData.append("U_CODE", props.user.U_CODE);
    formData.append("Tourist_Age_Type_Id", dataForm.Tourist_Age_Type_Id);
    
    let keylistReq = [
      "Tour_Dt_Id",
      "Tourist_Fa_FName",
      'Tourist_Fa_LName',
      'Tourist_National_Code',
      'Tourist_Mobile',
    ]
    for (let i = 0; i < keylistReq.length; i++) {
      const element = keylistReq[i];
      if(keys.findIndex(v => v === element) !== -1){
        formData.append(element, data[element]);
      } else {
          errors[element] = "پر شود"
      }
    }
    let keyListNotReq = [
      'Tourist_En_FName',
      'Tourist_En_LName',
      'Tourist_Passport_No',
      'Tourist_Passport_Exp_Date',
    ]
    for (let i = 0; i < keyListNotReq.length; i++) {
      const element = keyListNotReq[i];
      if(keys.findIndex(v => v === element) !== -1){
        formData.append(element, data[element]);
      }
    }
    if(Object.keys(errors).length){
      setDialogError(errors)
      return;
    }
    setDialogLoading(true);
    setDialogError({})

    let res = await PostDataPromise(`${apiMain}/api/v2/sale/V2_sale_contract/request_insert`, formData);
    console.log(res);
    setDialogLoading(false)
  }
  if(isNaN(parseInt(params.id))){
    return (
      <Navigate replace={true} to={`/${(lan ? "en" : "fa")}/tour`}/>
    )
  }
  if(!props.user.API_TOKEN){
    return (
      <Navigate replace={true} to={`/${(lan ? "en" : "fa")}/tour`}/>
    )
  }
  if(loading){
    return (
        <LoadingFull/>
    )
  }
  let lang = lan ? {...MainData.dict[0]} : {...MainData.dict[1]};
  return (
    <PageLayout 
      {...props} 
      language={lan ? {...MainData.dict[0]} : {...MainData.dict[1]}} 
      dict={MainData.dict} 
      mainLogo={MainData.mainLogo} 
      texts={MainData.texts} 
      nav={MainData.nav} 
      footer={MainData.footer} 
      login={MainData.login}
    >
      <Styles>
        <div className="navpad"></div>
        <div className='over-tour'>
          <div className='image'>
            <IconRouting className={"icon-def"}/>
            {
                (data.Tour_Image) ? (
                    <img src={data.Tour_Image} alt={data.Tour_Name} onError={(e) => e.target.style.opacity = 0}/>
                ) : ""
            }
          </div>
          <div className='base'>
            <h1 className='title1'>
              {lang.filename === "fa" ? data.Tour_Name : data.Tour_EnName}
            </h1>
            <div className='desc'>
              <IconBuilding/>
              <div className='text'>
                {lang.filename === "fa" ? data.Tour_Desc : data.Tour_EnDesc}
              </div>
            </div>
            {
              (data.City_Name && data.Country_Name) ? (
                <>
                <div className='desc' style={{alignItems: "center"}}>
                  <IconLocation/>
                  {
                    lang.filename === "fa" ? data.Country_Name : data.Country_En_Name
                  } - {
                    lang.filename === "fa" ? data.City_Name : data.City_En_Name
                  }
                </div>
                </>
              ) : ""
            }
            {
              (data.Currency_Id && data.Tour_Min_Price) ? (
                <>
                <div className='desc big' style={{alignItems: "center"}}>
                  {DictioneryPanel.packagesDict.startingPrice[lang.filename]}: <span className='desc-link'>{formatPrice(data.Tour_Min_Price)}</span> {data.Currency_Name} 
                </div>
                </>
              ) : ""
            }
          </div>
          <div className='end'>
            
          </div>
        </div>
        <div className='buying-forms'>
            <div className='form-1'>
              <TextInputWTitle
                  title={DictioneryPanel.touristsDict.personMobile[lang.filename]}
                  name={"Tourist_Mobile"}
                  value={(dataForm.Tourist_Mobile) ? dataForm.Tourist_Mobile : ""}
                  onchange={onChange}
                  error={(dialogError.Tourist_Mobile) ? dialogError.Tourist_Mobile : ""}
                  lan={(lang.filename !== "fa") ? true : false}
              />
              <div></div>
              <TextInputWTitle
                  title={DictioneryPanel.touristsDict.personFName[lang.filename]}
                  name={"Tourist_Fa_FName"}
                  value={(dataForm.Tourist_Fa_FName) ? dataForm.Tourist_Fa_FName : ""}
                  onchange={onChange}
                  error={(dialogError.Tourist_Fa_FName) ? dialogError.Tourist_Fa_FName : ""}
                  lan={(lang.filename !== "fa") ? true : false}
              />
              <TextInputWTitle
                  title={DictioneryPanel.touristsDict.personLName[lang.filename]}
                  name={"Tourist_Fa_LName"}
                  value={(dataForm.Tourist_Fa_LName) ? dataForm.Tourist_Fa_LName : ""}
                  onchange={onChange}
                  error={(dialogError.Tourist_Fa_LName) ? dialogError.Tourist_Fa_LName : ""}
                  lan={(lang.filename !== "fa") ? true : false}
              />
              <TextInputWTitle
                  title={DictioneryPanel.touristsDict.personNationalID[lang.filename]}
                  name={"Tourist_National_Code"}
                  value={(dataForm.Tourist_National_Code) ? dataForm.Tourist_National_Code : ""}
                  onchange={onChange}
                  error={(dialogError.Tourist_National_Code) ? dialogError.Tourist_National_Code : ""}
                  lan={(lang.filename !== "fa") ? true : false}
              />
              <AgeTypeV2Selector
                  title={DictioneryPanel.touristsDict.personAgeGroup[lang.filename]}
                  name={"Tourist_Age_Type_Id"}
                  value={(dataForm.Tourist_Age_Type_Id) ? dataForm.Tourist_Age_Type_Id : ""}
                  onchange={onChange}
                  error={(dialogError.Tourist_Age_Type_Id) ? dialogError.Tourist_Age_Type_Id : ""}
                  lan={(lang.filename !== "fa") ? true : false}
                  search={true}
              />

              <TextInputWTitle
                  title={DictioneryPanel.touristsDict.personFNameEn[lang.filename]}
                  name={"Tourist_En_FName"}
                  value={(dataForm.Tourist_En_FName) ? dataForm.Tourist_En_FName : ""}
                  onchange={onChange}
                  error={(dialogError.Tourist_En_FName) ? dialogError.Tourist_En_FName : ""}
                  lan={(lang.filename !== "fa") ? true : false}
              />
              <TextInputWTitle
                  title={DictioneryPanel.touristsDict.personLNameEn[lang.filename]}
                  name={"Tourist_En_LName"}
                  value={(dataForm.Tourist_En_LName) ? dataForm.Tourist_En_LName : ""}
                  onchange={onChange}
                  error={(dialogError.Tourist_En_LName) ? dialogError.Tourist_En_LName : ""}
                  lan={(lang.filename !== "fa") ? true : false}
              />
              <TextInputWTitle
                  title={DictioneryPanel.touristsDict.personPassportID[lang.filename]}
                  name={"Tourist_Passport_No"}
                  value={(dataForm.Tourist_Passport_No) ? dataForm.Tourist_Passport_No : ""}
                  onchange={onChange}
                  error={(dialogError.Tourist_Passport_No) ? dialogError.Tourist_Passport_No : ""}
                  lan={(lang.filename !== "fa") ? true : false}
              />
              <DateInputWTitle
                  title={DictioneryPanel.touristsDict.personPassportExp[lang.filename]}
                  name={"Tourist_Passport_Exp_Date"}
                  value={(dataForm.Tourist_Passport_Exp_Date) ? dataForm.Tourist_Passport_Exp_Date : ""}
                  onchange={onChange}
                  error={(dialogError.Tourist_Passport_Exp_Date) ? dialogError.Tourist_Passport_Exp_Date : ""}
                  lan={(lang.filename !== "fa") ? true : false}
              />
            </div>
            <div className='form-2'>
              <div className='hotel-selector'>

              </div>
              <div className='tour-price-data'>
                <div className='total'>
                  <div className='title'>
                    {DictioneryPanel.packagesDict.totalPrice[lang.filename]}:
                  </div>
                  <div className='value'>
                    {formatPrice(data.Tour_Min_Price)} {data.Currency_Name}
                  </div>
                </div>
              </div>
              <div className='actions'>
                <TextBtn2
                  text={DictioneryPanel.packagesDict.sendReq[lang.filename]}
                  onclick={sendData}
                  loading={dialogLoading}
                  disabled={dialogLoading}
                  newType={4}
                />
              </div>
            </div>
        </div>
        <div className="navpad"></div>
      </Styles>
    </PageLayout>
  )
}

